import { useContextSelector } from 'use-context-selector';
import { VGSFormContext } from './context';

export function useVgsFormMap() {
  return useContextSelector(VGSFormContext, (state) => state.formMap);
}

export function useVgsFormForPaymentSourceId(paymentSourceId: string) {
  return useContextSelector(VGSFormContext, (state) => state.formMap[paymentSourceId]);
}
